import { createFileRoute } from "@tanstack/react-router";
import AdminSignup from "@/pages/admin/AdminSignup";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/signup")({
  head: () => adminHead("Sign Up | Admin", "Request access to the admin dashboard.", "/admin/signup"),
  component: AdminSignup,
});
